export const START_MARK_PRE_DELAY = 'embed-script-start-pre-delay';
export const END_MARK_PRE_DELAY = 'embed-script-end-pre-delay';
export const START_MARK_POST_DELAY = 'embed-script-start-post-delay';
export const END_MARK_POST_DELAY = 'embed-script-end-post-delay';
export const EXECUTION_MEASUREMENT_POST_DELAY = 'embed-script-load-time-post-delay';
export const EXECUTION_MEASUREMENT_PRE_DELAY = 'embed-script-load-time-pre-delay';